import { useEffect, useRef } from "react";

export const Waveform = ({ analyserRef, active }) => {
  const canvasRef = useRef(null);
  const levelRef = useRef(null);

  useEffect(() => {
    let raf;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const draw = () => {
      const { width, height } = canvas.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;
      if (canvas.width !== width * dpr) { canvas.width = width * dpr; canvas.height = height * dpr; }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, width, height);
      const analyser = analyserRef.current;
      const bars = Math.floor(width / 6);
      let rms = 0;
      let data = null;
      if (analyser && active) {
        data = new Uint8Array(analyser.fftSize);
        analyser.getByteTimeDomainData(data);
        for (let i = 0; i < data.length; i++) { const v = (data[i] - 128) / 128; rms += v * v; }
        rms = Math.sqrt(rms / data.length);
      }
      const css = getComputedStyle(document.documentElement);
      const grad = ctx.createLinearGradient(0, 0, width, 0);
      grad.addColorStop(0, `hsl(${css.getPropertyValue("--primary").trim()})`);
      grad.addColorStop(1, `hsl(${css.getPropertyValue("--violet").trim()})`);
      ctx.fillStyle = grad;
      for (let i = 0; i < bars; i++) {
        let amp = 0.04;
        if (data) {
          const v = Math.abs(data[Math.floor((i / bars) * data.length)] - 128) / 128;
          amp = Math.max(0.04, Math.min(1, v * 2.2 + rms * 1.5));
        }
        const h = amp * height;
        ctx.beginPath();
        ctx.roundRect(i * 6, (height - h) / 2, 3, h, 2);
        ctx.fill();
      }
      if (levelRef.current) levelRef.current.style.width = `${Math.min(100, rms * 320)}%`;
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(raf);
  }, [analyserRef, active]);

  return (
    <div className="w-full">
      <canvas ref={canvasRef} className="h-24 w-full" data-testid="recording-waveform" />
      <div className="mt-4 flex items-center gap-3">
        <span className="eyebrow shrink-0">Niveau sonore</span>
        <div className="h-2 flex-1 overflow-hidden rounded-full bg-muted" data-testid="sound-level-meter">
          <div ref={levelRef} className="h-full rounded-full bg-gradient-to-r from-emerald-400 via-amber-400 to-red-500 transition-[width] duration-100" style={{ width: 0 }} />
        </div>
      </div>
    </div>
  );
};
